import { IOptionAnyValue } from 'bricks/types';
import {
    STRUCTURED_PARKING, SURFACE_PARKING, TRAILER_PARKING, UNDERGROUND_PARKING,
} from 'views/ProFormaTable/constants';
import { BasicInformationValues } from './types';

export const updateParkingAndSpaces = (formData: BasicInformationValues, parkingOptions: IOptionAnyValue[] | null) => {
    let updatedFormData = { ...formData };
    if (parkingOptions == null || parkingOptions.length === 0) {
        updatedFormData = {
            ...updatedFormData,
            parking: [],
            structuredParkingSpaces: null,
            surfaceParkingSpaces: null,
            undergroundParkingSpaces: null,
            trailerParkingSpaces: null,
        };
        return updatedFormData;
    }
    const newParkingValues = (parkingOptions || []).map((p: IOptionAnyValue) => p.value);
    updatedFormData = {
        ...updatedFormData,
        parking: parkingOptions,
        structuredParkingSpaces: newParkingValues.includes(STRUCTURED_PARKING) ? updatedFormData.structuredParkingSpaces : null,
        surfaceParkingSpaces: newParkingValues.includes(SURFACE_PARKING) ? updatedFormData.surfaceParkingSpaces : null,
        undergroundParkingSpaces: newParkingValues.includes(UNDERGROUND_PARKING) ? updatedFormData.undergroundParkingSpaces : null,
        trailerParkingSpaces: newParkingValues.includes(TRAILER_PARKING) ? updatedFormData.trailerParkingSpaces : null,
    };

    return updatedFormData;
};
